import { privateApi } from '@services/api';
import IDirectMessageChat, {
  DirectChatMessagePageParams,
} from '@th-types/direct-messages-chat.type';
import MessageRequest from '@th-types/message-request.type';
import IResultResponse from '@th-types/resultResponse.type';

const CHAT_URL = 'chat';

export const fetchDirectChatMessages = async (
  chatId: number | null | undefined,
  page?: DirectChatMessagePageParams
): Promise<IDirectMessageChat> => {
  if (!chatId) {
    return Promise.reject(new Error('No chat ID provided'));
  }

  const result = await privateApi.get<IDirectMessageChat>(
    `${CHAT_URL}/direct-messages/${chatId}`,
    { params: page }
  );
  return result.data;
};

export const sendDirectChatMessage = async (
  chatId: number | null,
  message: MessageRequest
): Promise<IResultResponse> => {
  if (!chatId) {
    return {
      success: false,
      status: 400,
      message: 'No chat ID provided',
    };
  }

  const result = await privateApi.post<IResultResponse>(
    `${CHAT_URL}/direct-messages/${chatId}/send`,
    message
  );
  return result.data;
};

export const markDirectChatAsRead = async (
  chatId: number | null | undefined
): Promise<IResultResponse> => {
  if (!chatId) {
    return Promise.reject(new Error('No chat ID provided'));
  }

  const result = await privateApi.post<IResultResponse>(
    `${CHAT_URL}/direct-messages/${chatId}/read`
  );
  return result.data;
};

export const markDirectChatAsUnread = async (
  chatId: number | null | undefined
): Promise<IResultResponse> => {
  if (!chatId) {
    return Promise.reject(new Error('No chat ID provided'));
  }

  const result = await privateApi.post<IResultResponse>(
    `${CHAT_URL}/direct-messages/${chatId}/unread`
  );
  return result.data;
};
